import { AutogenLayoutLoadUnloadCodes } from "./autogen/AutogenLayoutLoadUnloadCodes";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";

const viewCodeURL = "lme/dispatch/LoadUnloadCodes?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "load_unload",
    screenName: "Driver Load & Unload Code",
    navigateToUrl: viewCodeURL
};

export class LoadUnloadCodes extends AutogenLayoutLoadUnloadCodes {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }
}